import api from '../utils/api';

const getToken = () => sessionStorage.getItem('token');

export const getFactusUserData = async () => {
    const token = getToken();
    const response = await api.get("/facturation/users/me/factus-data", {
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });

    if (response.status === 404) {
        return null; // No hay datos fiscales, no es un error
    }
    
    return response.data;
};

export const createOrUpdateFactusUserData = async (userData) => {
    const token = getToken();
    const response = await api.post("/facturation/users/me/factus-data", userData, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    return response.data;
};
export const getTransactionByBookingId = async (bookingId) => {
    const token = getToken();
    const response = await api.get(`/facturation/transaction/booking/${bookingId}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });
    return response.data;
};
export const getFactusUserDataByUserId = async (userId) => {
    try {
        const token = getToken();
        const response = await api.get(`/facturation/users/${userId}/factus-data`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 404) {
            return null; // No hay datos fiscales, no es un error
        }
        throw error;
    }
};